import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getBaseUrl } from '@core/utilities/runtime.utils';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const AUTH_CONFIG_URL = '/api/v1/authentication/configuration';
let baseUrl = getBaseUrl();
if (environment.production) {
  enableProdMode();
}

const getProtectedResourceUrl = (resourceUrl: string) => {
  const normalizedUrl = resourceUrl?.replace(/\/+$/, '') ?? '';
  return normalizedUrl.includes('*') ? normalizedUrl : `${normalizedUrl}/*`;
};

// using a service doesn't work at this part of the application lifecycle
// as injectable services are not available
fetch(baseUrl + AUTH_CONFIG_URL)
  .then(resp => resp.json())
  .then(async env => {
    environment.msalConfig = env.msalConfig;
    environment.b2cPolicies = env.b2cPolicies;
    environment.apiConfig = env.apiConfig;
    environment.apiConfig.baseUrl = baseUrl;

    const msalInstance = new PublicClientApplication({
      auth: {
        clientId: env.msalConfig.auth.clientId,
        authority: env.b2cPolicies.authorities.signIn.authority,
        redirectUri: '/',
        postLogoutRedirectUri: '/login',
        knownAuthorities: [env.b2cPolicies.authorityDomain]
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback(logLevel: LogLevel, message: string) {
            //console.log('MSAL Angular: ',  message);
          },
          logLevel: LogLevel.Trace,
          piiLoggingEnabled: false
        }
      }
    });

    await msalInstance.initialize();

    platformBrowserDynamic([
      {
        provide: MSAL_INSTANCE,
        useValue: msalInstance
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useValue:  {
          interactionType: InteractionType.Redirect,
          authRequest: {
            scopes: [...env.apiConfig.scopes],
          },
          loginFailedRoute: '/login'
        }
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: () => 
        {
          const protectedResourceMap = new Map<string, Array<string>>();
          // Match the same URL used by the generated API clients. In MSAL Angular v5,
          // a bare base URL no longer matches its child paths unless it has a wildcard.
          protectedResourceMap.set(getProtectedResourceUrl(environment.apiConfig.baseUrl), env.apiConfig.scopes);

          return {
            interactionType: InteractionType.Redirect,
            protectedResourceMap
          }
        }
      }
    ]
  ) .bootstrapModule(AppModule).catch(err => console.error(err))
})
.catch(err => console.error(err));
